import { queries as couponsQueries } from "domains/admin/containers/BusinessCoupons/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: Parameters<typeof couponsQueries>[0]): Array<WarmableQuery> => couponsQueries(input);
